// extracted by mini-css-extract-plugin
export default {"avatarWrapper":"RequestsChatAvatar_avatarWrapper__5lprn","img":"RequestsChatAvatar_img__mU-kQ","date":"RequestsChatAvatar_date__VQMxk"};